import { memo, FC, Fragment, useState } from 'react'
import { useAiAssistantThreadListMessageList } from './useAiAssistantThreadListMessageList'
import { getChatMessageListItemDomId } from 'utils/chat'
import { ChatView } from '@crew/enums/app'
import { AiAssistantThreadListMessageListItem } from './components/aiAssistantThreadListMessageListItem/aiAssistantThreadListMessageListItem'
import { useValueChangeEffect } from '@crew/hooks'
import { ChatMessage } from '@crew/models/domain'
import { AiAssistantThreadListTipsMessageItem } from './components/aiAssistantThreadListTipsMessageItem/aiAssistantThreadListTipsMessageItem'
import { CrewDivider } from 'components/elements/crewDivider/crewDivider'

type AiAssistantThreadListMessageListProps = {
  onMessageEdit: (message: ChatMessage) => void // メッセージ編集時のコールバック
  selectedItemId?: string // 選択中のメッセージ。ハイライト用に使用する
  showTipsMessageItem: boolean // AIアシスタントの上部のメッセージを表示するかどうか
}

/**
 * AIアシスタント - スレッドリスト形式のメッセージ一覧
 */
export const AiAssistantThreadListMessageList: FC<AiAssistantThreadListMessageListProps> =
  memo((props) => {
    const { displayItems, itemsScrollableDivRef } =
      useAiAssistantThreadListMessageList()

    const [selectedMessageId, setSelectedMessageId] = useState<
      string | undefined
    >(undefined)

    useValueChangeEffect(
      () => {
        setSelectedMessageId(props.selectedItemId)
      },
      [props.selectedItemId],
      props.selectedItemId
    )

    return (
      <>
        {props.showTipsMessageItem && (
          <>
            {/* Tipsメッセージ */}
            <AiAssistantThreadListTipsMessageItem />

            {/* 区切り線 */}
            <CrewDivider />
          </>
        )}
        <div
          className="grow flex overflow-y-scroll flex-col-reverse"
          ref={itemsScrollableDivRef}
        >
          <div className="grow flex flex-col">
            {displayItems.map((item) => (
              <Fragment key={item.id}>
                <AiAssistantThreadListMessageListItem
                  key={item.id}
                  // スクロール位置制御のためChatViewを含めたidとして指定する
                  id={getChatMessageListItemDomId(
                    item.messageId,
                    ChatView.ThreadList
                  )}
                  replyCount={item.threadReplyCount}
                  chatMessageId={item.messageId}
                  container={itemsScrollableDivRef}
                  onAdditionalLoading={item.handleAdditionalLoading}
                  selectedItemId={selectedMessageId}
                  setSelectedItemId={setSelectedMessageId}
                  onMessageEdit={props.onMessageEdit}
                />
              </Fragment>
            ))}
          </div>
        </div>
      </>
    )
  })
